import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DxTreeViewComponent } from 'devextreme-angular';
import { alert } from 'devextreme/ui/dialog';
import { ComponentService } from '../../../services/component.service';

@Component({
  selector: 'app-crm-email-inviate',
  templateUrl: './crm_email_inviate.component.html',
  styleUrls: ['./crm_email_inviate.component.css']
})
export class CrmEmailInviateComponent {
  constructor(private componentService: ComponentService) { }
  optionalButton(e) {
    console.log(e)
    if (e.name === 'showContent') {
      let guid = Math.random().toString().replace("0.", "")
      this.componentService.setNewPopUp(guid, 'NicaPopupTextComponent', null, '600', null, { contenuto: e.row.data.contenuto }, false, true, 'Email Inviata', 'top')
      // alert(e.row.data.contenuto, 'Tie')
    }
  }
}